<template>
  <div class="Site_main">
    <div class="Site_Left_Content">
      <div class="Site_Left_part1">
        <div class="top">
          <el-select
            class="top-select"
            v-model="$store.state.cursite"
            filterable
            placeholder="请选择"
            @change="getDetailInfo(), getSiteDetailInfo()"
          >
            <el-option
              v-for="item in $store.state.siteList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>

          <div class="status-span backgroundCorner">
            <span style="color: #7f8488">状态说明:</span>
            <div style="display: flex; align-items: center">
              <img src="../../../assets/greenIcon.png" alt="" />
              <div class="status-G-box">
                <span>正常</span>
              </div>
            </div>
            <div style="display: flex; align-items: center">
              <img src="../../../assets/yellowIcon.png" alt="" />
              <div class="status-Y-box">
                <span>预警</span>
              </div>
            </div>
            <div style="display: flex; align-items: center">
              <img src="../../../assets/redIcon.png" alt="" />
              <div class="status-R-box">
                <span>告警</span>
              </div>
            </div>
            <div style="display: flex; align-items: center">
              <img src="../../../assets/grayIcon.png" alt="" />
              <div class="status-O-box">
                <span>离线</span>
              </div>
            </div>
          </div>
        </div>
        <div class="bottom">
          <div
            v-for="(item, index) in liftList"
            :key="item.id"
            class="bottom_Box"
          >
            <div
              style="position: relative"
              @mouseenter="enter(item, index)"
              @mouseleave="leave(item, index)"
              @mousemove="move"
              @click="torealTime(item)"
              :class="
                item.status == 1
                  ? 'bottom_BoxBg_g'
                  : item.status == 2
                  ? 'bottom_BoxBg_r'
                  : item.status == 3
                  ? 'bottom_BoxBg_y'
                  : 'bottom_BoxBg_o'
              "
            >
              <img
                v-if="item.status != 4"
                :src="
                  item.type == 'elevator'? `${require('../../../assets/liftcon.png')}`: 
                    item.type == 'escalator'? `${require('../../../assets/h-liftcon.png')}`:
                    item.type == 'eMachinery'? `${require('../../../assets/eMachineryIcon.png')}`:
                    item.type == 'eWaterPump'? `${require('../../../assets/eMachineryIcon.png')}`:
                    item.type == 'FanMotor'? `${require('../../../assets/eMachineryIcon.png')}`:
                    `${require('../../../assets/liftcon.png')}`
                "
                style="height: 100%; width: 85%"
                alt=""
              />
              <img
                v-else
                :src="
                  item.type != 'elevator'? `${require('../../../assets/oliftcon.svg')}`: 
                  item.type != 'escalator'? `${require('../../../assets/oh-liftcon.svg')}`: 
                  item.type != 'eMachinery'? `${require('../../../assets/o-eMachineryIcon.png')}`: 
                  item.type != 'eWaterPump'? `${require('../../../assets/o-eMachineryIcon.png')}`: 
                  item.type != 'FanMotor'? `${require('../../../assets/o-eMachineryIcon.png')}`: 
                  `${require('../../../assets/oliftcon.svg')}`
                "
                style="height: 100%; width: 85%"
                alt=""
              />

              <div v-show="popUpShow" class="hover_con" :style="positionStyle">
                <div class="hover_top">
                  <div class="hover_line"></div>
                  <span>{{ curItem.remark }}</span>
                </div>

                <div class="hover_bottom">
                  <div class="detailInfo">
                    <span>检测点：</span>
                    <span class="firstSpan">{{ curItem.sensorCount }}</span>
                  </div>
                  <div class="detailInfo">
                    <span>正常运行：</span>
                    <span>{{ curItem.normalSensorCount }}</span>
                  </div>
                  <div class="detailInfo">
                    <span>异常运行：</span>
                    <span>{{ curItem.abnormalSensorCount }}</span>
                  </div>
                  <div class="detailInfo">
                    <span>告警数据：</span>
                    <span>{{ curItem.warningCount }}</span>
                  </div>
                </div>
              </div>
            </div>
            <!-- 告警红色，暂时没告警，都改成黄色 #f33d3d4a -->
            <div
              @click="getSensorHistory(item)"
              :style="
                item.status == 1 && item.remark === curElevator.remark
                  ? 'background:#44d7b64a'
                  : item.status == 2 && item.remark === curElevator.remark
                  ? 'background:#f33d3d4a'
                  : item.status == 3 && item.remark === curElevator.remark
                  ? 'background:#dcb26e4a'
                  : item.status == 4 && item.remark === curElevator.remark
                  ? 'background:#7f848873'
                  : ''
              "
            >
              <div
                :class="
                  item.status == 1
                    ? 'bottom_border_g'
                    : item.status == 2
                    ? 'bottom_border_r'
                    : item.status == 3
                    ? 'bottom_border_y'
                    : 'bottom_border_o'
                "
              >
                <span style="display: inline-block"></span>
                <span> {{ item.remark }} </span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="Site_Left_part2">
        <div class="titleBox">
          <img src="../../../assets/square-point.png" alt="" />
          <span
            style="cursor: pointer"
            @click="$router.push('/home/audioAnalysis')"
            >运行负载</span
          >
          <!-- <span>{{ curElevator.remark }}</span> -->
        </div>
        <div style="height: 90%; width: 100%">
          <!-- <lineChart style="width: 100%; height: 100%"></lineChart>
           -->
          <vibration-chart ref="elevatorMotorChart" title="电机负载(ap)" />
        </div>
      </div>
    </div>
    <div class="Site_Right_Content">
      <div class="Site_Right_part1">
        <div class="titleBox">
          <img src="../../../assets/square-point.png" alt="" />
          <span>运行概览</span>
        </div>

        <div style="flex: 1">
          <pieChart
            ref="pieChart"
            style="width: 100%; height: 100%"
            :cursiteInfo="cursiteInfo ? cursiteInfo : {}"
          >
          </pieChart>
        </div>
        <div
          style="
            flex: 1;
            display: flex;
            flex-wrap: wrap;
            justify-content: center;
          "
        >
          <div class="rightInfo_box">
            <img src="../../../assets/rightcon1.png" alt="" />
            <div class="box_item">
              <span>{{
                cursiteInfo ? cursiteInfo.normalElevatorCount : "一"
              }}</span>
              <span>正常运行</span>
            </div>
          </div>
          <div class="rightInfo_box">
            <img src="../../../assets/rightcon2.png" alt="" />
            <div class="box_item">
              <span>{{
                cursiteInfo
                  ? cursiteInfo.warningElevatorCount +
                    cursiteInfo.alarmElevatorCount +
                    cursiteInfo.unOnlineElevatorCount
                  : "一"
              }}</span>
              <span>异常运行</span>
            </div>
          </div>
          <div
            class="rightInfo_box"
            :style="
              cursiteInfo && cursiteInfo.alarmWarningCount > 0
                ? 'box-shadow: inset 0px 0px 6px 0px #e02020;border-radius: 2px;border: 1px solid #f33d3d;cursor: pointer;'
                : 'cursor: pointer;'
            "
            @click="$router.push('/home/warnSearch')"
          >
            <img
              :src="
                cursiteInfo && cursiteInfo.alarmWarningCount > 0
                  ? `${require('../../../assets/rightcon3.png')}`
                  : `${require('../../../assets/rightcon3s.png')}`
              "
              alt=""
            />
            <div class="box_item">
              <span
                :style="
                  cursiteInfo && cursiteInfo.alarmWarningCount > 0
                    ? 'color:#F33D3D'
                    : ''
                "
                >{{ cursiteInfo ? cursiteInfo.alarmWarningCount : "一" }}</span
              >
              <span>告警数据</span>
            </div>
          </div>
          <div
            class="rightInfo_box"
            :style="
              cursiteInfo && cursiteInfo.warningCount > 0
                ? 'box-shadow: inset 0px 0px 6px 0px #DCB26E;border-radius: 2px;border: 1px solid #DCB26E;cursor: pointer;'
                : 'cursor: pointer;'
            "
            @click="$router.push('/home/warnSearch')"
          >
            <img
              :src="
                cursiteInfo && cursiteInfo.warningCount > 0
                  ? `${require('../../../assets/rightcon4.png')}`
                  : `${require('../../../assets/rightcon4s.png')}`
              "
              alt=""
            />

            <div class="box_item">
              <span
                :style="
                  cursiteInfo && cursiteInfo.warningCount > 0
                    ? 'color:#F7B500'
                    : ''
                "
                >{{ cursiteInfo ? cursiteInfo.warningCount : "一" }}</span
              >
              <span>预警数据</span>
            </div>
          </div>
        </div>
      </div>
      <div class="Site_Right_part2">
        <div class="bottom-top">
          <img src="../../../assets/square-point.png" alt="" />
          <span @click="flag = 1" :class="flag === 1 ? 'bottom-t1' : 'bottom-t2'">预警信息</span>
          <span class="bottom-t2">/</span>
          <span @click="flag = 2" :class="flag === 2 ? 'bottom-t1' : 'bottom-t2'">设备列表</span>
        </div>
        <div style="flex: 1; overflow: hidden; width: 99%; padding-top: 1.875rem">
          <el-table
            v-if="flag == 2"
            size="mini"
            ref="sensorTable"
            :data="sensorList"
            class="Table"
            :highlight-current-row="true"
            :show-header="false"
            @row-click="torealTimeByEquip"
            :row-style="{
              fontSize: '12px',
              color: '#7F8488',
              height: '34px',
            }"
          >
            <el-table-column
              header-align="center"
              align="center"
              prop="elevatorName"
              label="设备名"
            >
            </el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              prop="position"
              label="部件名"
            >
            </el-table-column>
            <el-table-column header-align="center" align="center" label="状态">
              <template slot-scope="scope">
                <span
                  :style="
                    scope.row.status == 1
                      ? 'color:#44D7B6'
                      : scope.row.status == 2
                      ? 'color:#F33D3D'
                      : scope.row.status == 3
                      ? 'color:rgb(247, 181, 0)'
                      : ''
                  "
                  >{{
                    scope.row.status == 1
                      ? "正常"
                      : scope.row.status == 2
                      ? "告警"
                      : scope.row.status == 3
                      ? "预警"
                      : "离线"
                  }}</span
                >
              </template>
            </el-table-column>
          </el-table>

          <el-table
            v-else
            size="mini"
            ref="Table"
            :data="warningList"
            class="Table"
            :highlight-current-row="true"
            :show-header="false"
            @row-click="torealTimeByAudio"
            :row-class-name="tableRowClassName"
            :row-style="{
              fontSize: '0.75rem',
              color: '#7F8488',
              height: '2.125rem',
            }"
          >
            <el-table-column
              header-align="center"
              align="center"
              prop="elevatorName"
              label="设备名"
            >
            </el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              prop="position"
              label="预警位置"
            >
            </el-table-column>

            <el-table-column
              header-align="center"
              align="center"
              label="faultType"
            >
              <template slot-scope="scope">
                <span
                  :style="
                    scope.row.level == 2
                      ? 'color:#F33D3D'
                      : 'color:rgb(247, 181, 0)'
                  "
                >
                  {{ scope.row.level == 2 ? "运行告警" : "运行预警" }}
                </span>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </div>
  </div>
</template>
  
<script>
import containerHeader from "@/components/container_header.vue";
import lineChart from "@/components/lineChart.vue";
import pieChart from "@/components/pieChart.vue";
import vibrationChart from "@/components/vibration-chart.vue";
import axios from "axios";
export default {
  components: {
    containerHeader,
    lineChart,
    pieChart,
    vibrationChart,
  },
  data() {
    return {
      curItem: {},
      popUpShow: false,
      positionStyle: { top: "0px", left: "0px" },
      options: [],
      cursite: "",
      filteredData: [],
      liftList: [],
      flag: 1, //1是预警列表，2是设备列表,
      warningList: [],
      sensorList: [],
      elevatorList: [],
      siteList: [],
      cursiteInfo: {},
      curVibrationSensorList: [],
      curMovementSensor: [],
      curElevator: {},
      curlift: "",
      timer: null, //图表定时器
    };
  },
  beforeDestroy() {
    this.clearTimer();
  },
  deactivated() {
    this.clearTimer();
  },
  activated() {
    this.$refs.pieChart.windowResize();
  },
  mounted() {
    console.log(this.$store.state.cursite);
    setTimeout(() => {
      this.getelevatorList();
    }, 500);
  },
  watch: {
    flag() {
      if (this.flag == 1) {
        this.getWarningList(this.curElevator.id);
      } else {
        this.getSensorListList();
      }
    },
    "$store.state.motorTimeRange": function () {
      this.requestMotorHistoryData();
    },
  },
  methods: {
    clearTimer() {
      clearInterval(this.timer);
      this.timer = null;
    },
    // getfalutTypeName(faultType){
    //   switch(faultType){
    //     case 1 :
    //       return ''
    //   }
    // },
    torealTimeByEquip() {
      this.$router.push({
        path: "/home/realTime",
        query: { id: this.curElevator.id },
      });
    },
    torealTimeByAudio(item) {
      this.$store.state.curAudioData = item;
    if (item.usbPort == 106){
      this.$router.push({
        path: "/home/temperature",
        query: { id: item.elevatorId },
      });
    }else {
      this.$router.push({
        path: "/home/realTime",
        query: { id: item.elevatorId },
      });
    }
     
    },
    torealTime(item) {
          if(item.isTemperError == 1 ){
            this.$router.push({path: "/home/temperature", query: {id: item.id}});
          }else {
            this.$router.push({path: "/home/realTime", query: {id: item.id}});

          }
        },
    toAnalysis(item) {
      this.$store.state.curElevatorInfo = item;
      this.$router.push("/home/audioAnalysis");
      this.$store.state.curElevatorID = item.id;
    },
    getSensorHistory(i) {
      console.log(i.id);
      this.$store.state.curElevatorInfo = i;
      this.$store.state.curElevatorID = i.id;
      this.curElevator = i;
      this.getSensorList(i.id);
      this.getWarningList(i.id);
    },
    //获取传感器列表
    getSensorList(id) {
      clearInterval(this.timer);
      this.timer = null;

      const params = {
        elevatorId: id,
      };
      this.$api.sensor.list(params).then((res) => {
        if (res.code == 200 && res.data && res.data.length > 0) {
          //图表组件延迟加载
          // setTimeout(() => {
          //   this.isInit = true;
          // }, 500);
          this.sensorList = res.data;
          console.log(this.sensorList);
          this.curVibrationSensorList = [];
          this.$store.state.curSensorList = res.data;
          this.sensorList.forEach((item) => {
            if (item.sensorType === 1 || item.sensorType === 8) {
              this.curVibrationSensorList.push(
                item.sensorId
              );
            } else if (item.sensorType === 2) {
              this.curMovementSensor = item.sensorId;
            }
          });
          //定时刷新全部图表;
          //默认取最近一小时的时间
          //先执行一次
          this.clearTimer();
          this.requestMotorHistoryData();
          this.timer = setInterval(() => {
            this.requestMotorHistoryData();
          }, 10000);
        } else {
          this.sensorList = [];
        }
      });
    },
    requestMotorHistoryData() {
      if (this.curVibrationSensorList.length === 0) {
        return;
      }
      //电机负载
      let motorRange = this.$store.state.motorTimeRange;
      const rangeAmount = parseInt(motorRange.substr(0, 1));
      const rangeUnit = motorRange.substr(1, 1);
      let motorInterval = "1m";
      if (motorRange === "1h") {
        motorInterval = "5s";
      } else if (motorRange === "1d") {
        motorInterval = "1m";
      } else if (motorRange === "1w") {
        motorInterval = "5m";
      }
      let params = {
        interval: motorInterval,
        sensorList: this.curVibrationSensorList.join(","),
        dataType: 1,
        elevatorId: this.curElevator.id,
        startTime: this.$moment()
          .subtract(rangeAmount, rangeUnit)
          .format("yyyy-MM-DD HH:mm:ss"),
        // startTime:'2023-07-05 16:53:00',
        endTime: this.$moment().format("yyyy-MM-DD HH:mm:ss"),
      };
      this.$api.sensor.sensorHistory(params).then((res) => {
        if (res.code === "200") {
          console.log(res.data);
          const data = this.SensorHistoryToEchartData(1, res.data);
          this.$refs.elevatorMotorChart.setData(data);
        }
      });
    },
    SensorHistoryToEchartData(dataType, data) {
      //次数
      if (dataType == 5) {
        const chartDataX = data.time;
        const chartDataY = data.counts;
        return { chartDataX, chartDataY };
      }

      //倾角
      if (dataType == 4) {
        const chartDataX = data.time;
        const chartDataY = [
          {
            type: "line",
            name: "x",
            data: data.x,
            showSymbol: false,
            color: "#e6a23c",
            areaStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                {
                  offset: 0,
                  color: "#e6a23c80",
                },
                {
                  offset: 1,
                  color: "#e6a23c",
                },
              ]),
            },
          },
          {
            type: "line",
            name: "y",
            data: data.y,
            showSymbol: false,
            itemStyle: {
              color: "#00d1ed",
            },
            areaStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                {
                  offset: 0,
                  color: "#00d1ed",
                },
                {
                  offset: 1,
                  color: "#00d1eda3",
                },
              ]),
            },
          },
        ];

        let legendData = [];
        if (chartDataX && chartDataX.length != 0) {
          legendData = ["x", "y"];
        }

        return { chartDataX, chartDataY, legendData };
      }

      //里程
      if (dataType === 3) {
        const chartDataX = data.time;
        const chartDataY = data.distances;
        return { chartDataX, chartDataY };
      }

      //速度
      if (dataType === 2) {
        const chartDataX = data.time;
        const chartDataY = data.speed;
        return { chartDataX, chartDataY };
      }

      //振动传感器
      if (dataType === 1) {
        const chartDataX = data.time;
        const chartDataY = !data.data
          ? null
          : data.data.map((item, index) => {
              return {
                type: "line",
                name: item.position,
                data: item.energy,
                showSymbol: false,
                // itemStyle: {
                //     color:  "#ff0000"
                // }
                // areaStyle: {
                // color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                //     {
                //         offset: 0,
                //         color:
                //             index == 0
                //                 ? "#00d1ed"
                //                 : index == 1
                //                 ? "#e6a23c"
                //                 : "#ff4646",
                //     },
                //     {
                //         offset: 1,
                //         color:
                //             index == 0
                //                 ? "#00d1eda3"
                //                 : index == 1
                //                 ? "#e6a23c80"
                //                 : "#ff464680",
                //     },
                // ]),
                // },
              };
            });
        let legendData = [];
        if (data.time && data.time.length != 0) {
          data.data.forEach((item) => {
            legendData.push(item.position);
          });
        }
        return { chartDataX, chartDataY, legendData };
      }
    },
    getSiteDetailInfo() {
      const params = {
        siteId: this.$store.state.cursite,
      };
      this.$api.elevator.getElevatorStatics(params).then((res) => {
        if (res.code == 200) {
          console.log(res.data);
          this.cursiteInfo = res.data;
        }
      });
    },
    getDetailInfo() {
      const params = {
        pageNo: 1,
        pageSize: 100,
        isDetail: 1,
        siteId: this.$store.state.cursite,
      };
      this.$api.elevator.pagelist(params).then((res) => {
        if (res.code == 200) {
          console.log(res.data.records);
          this.liftList = res.data.records;

          this.getSensorHistory(this.liftList[0]);
          this.curElevator = this.liftList[0];
        }
      });
    },
    getelevatorList() {
      this.$api.elevator.list().then((res) => {
        if (res.code == 200) {
          console.log(res.data);
          this.elevatorList = res.data;
          // 使用一个Map存储唯一的customer和id
          const uniqueCustomersMap = new Map();
          res.data.forEach((item) => {
            uniqueCustomersMap.set(item.customer, item.id);
          });

          console.log(uniqueCustomersMap);
          // 将Map转换为数组，并整理数据格式
          const formattedData = Array.from(
            uniqueCustomersMap,
            ([label, id]) => ({
              label,
              id,
            })
          );
          this.siteList = formattedData;
          console.log(formattedData);
          if (!this.$store.state.cursite) {
            this.$store.state.cursite = this.$store.state.siteList[0].id;
          }

          // this.$store.state.cursite = this.$store.state.siteList[0].name;

          //初始化
          this.getDetailInfo();
          this.getSiteDetailInfo();
        }
      });
    },
    getSensorListList() {
      const params = {
        elevatorId: this.curElevator.id,
      };
      this.$api.sensor.list(params).then((res) => {
        if (res.code == 200) {
          this.sensorList = res.data;
        }
      });
    },
    getWarningList(id) {
      const params = {
        pageNo: 1,
        pageSize: 999,
        elevatorId: id,
      };
      this.$api.warning.page(params).then((res) => {
        if (res.code == 200) {
          this.warningList = res.data.records.filter((item) => {
            return item.status == 1;
          });
          // if (this.warningList.length > 0) {
          //   this.$refs.Audio.warningData = this.warningList[0]
          //   this.$refs.Audio.getWarningAudio()
          // } else {
          //   this.$refs.Audio.clear()
          // }
        }
      });
    },
    tableRowClassName({ row, rowIndex }) {
      //配置表格行的index
      row.index = rowIndex;
    },
    enter(item, index) {
      this.popUpShow = true;
      this.curItem = item;
      // this.liftList[index].popUpShow= true;
    },
    leave(index) {
      this.popUpShow = false;

      // this.liftList[index].popUpShow= false;
    },
    move(event) {
      const x = event.pageX + 15 + "px";
      const y = event.pageY + 10 + "px";
      this.positionStyle = { top: y, left: x };
    },
    handleOpen(key, keyPath) {
      console.log(key, keyPath);
    },
    handleClose(key, keyPath) {
      console.log(key, keyPath);
    },
  },
  computed: {},
};
</script>
  
<style lang="less" scoped>
.Site_main {
  width: 100%;
  height: 100%;
  font-size: 1.5rem;
  z-index: 15;
  overflow: auto;
  box-sizing: border-box;
  display: flex;

  /* 清除表格横线 */
  /deep/ .el-table__row > td,
  th {
    border: none !important;
  }
}

.titleBox {
  display: flex;
  align-items: center;
  margin: 0.8125rem 0px 0rem 1.5rem;

  img {
    width: 1rem;
    margin-right: 0.625rem;
    height: 1rem;
    background: rgba(68, 215, 202, 0.33);
    border: 0.0625rem solid #44d7b6;
  }

  span {
    width: 4rem;
    height: 1rem;
    font-size: 1rem;
    font-family: SourceHanSansCN-Regular, SourceHanSansCN;
    font-weight: 400;
    color: #44d7b6;
    line-height: 1.125rem;
  }
}

.Site_Left_Content {
  flex: 2.5;
  display: flex;
  flex-direction: column;

  .el-input__inner {
    width: 13.4375rem;
    height: 2.5rem !important;
    line-height: 2.5rem !important;
    font-size: 0.9375rem !important;
  }

  .el-select {
    width: 13.4375rem !important;
    height: 2.5rem !important;
    line-height: 2.5rem !important;
  }

  .el-input {
    width: 13.4375rem !important;
    height: 2.5rem !important;
    line-height: 2.5rem !important;
    font-size: 0.9375rem !important;
  }

  .Site_Left_part1 {
    background: url(../../../assets/siteBG.png) no-repeat;
    background-size: 100% 100%;
    height: 60%;
    width: 100%;
    margin-bottom: 0.9375rem;
    display: flex;
    flex-direction: column;

    .top {
      height: 10%;
      display: flex;
      align-items: center;
      justify-content: space-between;

      .top-select {
        margin-left: 1.25rem;
      }

      .status-span {
        margin-right: 1.25rem;
        font-size: 0.75rem;
        color: #ffffff;
        line-height: 2.5rem;
        width: 23.25rem;
        height: 2.5rem;
        backdrop-filter: blur(0.0625rem);
        display: flex;
        align-items: center;
        justify-content: space-around;
        box-shadow: 0 0 40px var(--statusbg-color) inset;

        img {
          width: 0.9375rem;
          height: 0.9375rem;
          padding: 0 0.3125rem;
        }

        .status-G-box {
          width: 2.9375rem;
          height: 1.6875rem;
          line-height: 1.6875rem;
          background: rgba(91, 179, 188, 0.3);
          border: 0.0625rem solid #5bb3bc;
          color: #5bb3bc;
          text-align: center;
        }

        .status-Y-box {
          width: 2.9375rem;
          height: 1.6875rem;
          line-height: 1.6875rem;
          background: rgba(220, 178, 110, 0.3);
          border: 0.0625rem solid #dcb26e;
          color: #dcb26e;
          text-align: center;
        }

        .status-O-box {
          width: 2.9375rem;
          height: 1.6875rem;
          line-height: 1.6875rem;
          background: rgba(255, 248, 237, 0);
          border: 0.0625rem solid #7f8488;
          color: #7f8488;
          text-align: center;
        }

        .status-R-box {
          width: 2.9375rem;
          height: 1.6875rem;
          line-height: 1.6875rem;
          background: rgba(243, 61, 61, 0.3);
          border: 0.0625rem solid #f33d3d;
          color: #f33d3d;
          text-align: center;
        }
      }

      .backgroundCorner {
        background: linear-gradient(to top, #4d97a0, #4d97a0) left top no-repeat,
          //上左
          linear-gradient(to right, #4d97a0, #4d97a0) left top no-repeat,
          //左上
          linear-gradient(to left, #4d97a0, #4d97a0) right top no-repeat,
          //上右
          linear-gradient(to bottom, #4d97a0, #4d97a0) right top no-repeat,
          //上右
          linear-gradient(to left, #4d97a0, #4d97a0) left bottom no-repeat,
          //下左
          linear-gradient(to bottom, #4d97a0, #4d97a0) left bottom no-repeat,
          //左下
          linear-gradient(to top, #4d97a0, #4d97a0) right bottom no-repeat,
          //下右
          linear-gradient(to left, #4d97a0, #4d97a0) right bottom no-repeat; //右下
        background-size: 0.0625rem 0.375rem, 0.375rem 0.0625rem,
          0.0625rem 0.375rem, 0.375rem 0.0625rem;
      }
    }

    .bottom {
      flex: 1;
      display: flex;
      flex-wrap: wrap;
      overflow: auto;
      justify-content: flex-start;

      .bottom_Box {
        height: 9.0625rem;
        width: 9.125rem;
        padding: 2.5rem 2.5rem 0px 2.5rem;
        text-align: left;
        cursor: pointer;
        .bottom_BoxBg_o {
          width: 9.125rem;
          height: 7rem;
          text-align: center;
        }

        .bottom_BoxBg_o:hover {
          background: rgba(255, 248, 237, 0);
          width: 9.125rem;
          height: 7rem;
        }
        .bottom_BoxBg_y {
          width: 9.125rem;
          height: 7rem;
          text-align: center;
        }

        .bottom_BoxBg_y:hover {
          background: rgba(247, 181, 0, 0.2);
          width: 9.125rem;
          height: 7rem;
        }

        .bottom_BoxBg_r {
          width: 9.125rem;
          height: 7rem;
          text-align: center;
        }

        .bottom_BoxBg_r:hover {
          background: rgba(243, 61, 61, 0.5);
          width: 9.125rem;
          height: 7rem;
        }

        .bottom_BoxBg_g {
          width: 9.125rem;
          height: 7rem;
          text-align: center;
        }

        .bottom_BoxBg_g:hover {
          background: #154446;
          width: 9.125rem;
          height: 7rem;
        }

        .bottom_border_o {
          width: 9.125rem;
          height: 1.75rem;
          border: 0.0625rem solid #7f8488;
          font-size: 0.75rem;
          color: #7f8488;
          position: relative;
          margin-top: 0.625rem;
          line-height: 1.75rem;

          span:nth-of-type(1) {
            width: 1.725rem;
          }

          span {
            display: inline-block;
            width: 7.4rem;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
          }
        }

        .bottom_border_o::before {
          width: 0.625rem;
          height: 0.625rem;
          content: url(../../../assets/grayIcon.svg);
          position: absolute;
          left: 0.625rem;
          top: 0.1875rem;
        }

        .bottom_border_g {
          width: 9.125rem;
          height: 1.75rem;
          border: 0.0625rem solid #44d7b6;
          font-size: 0.75rem;
          color: #44d7b6;
          position: relative;
          margin-top: 0.625rem;
          line-height: 1.75rem;

          span:nth-of-type(1) {
            width: 1.725rem;
          }

          span {
            display: inline-block;
            width: 7.4rem;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
          }
        }

        .bottom_border_g::before {
          width: 0.625rem;
          height: 0.625rem;
          content: url(../../../assets/greenIcon.png);
          position: absolute;
          left: 0.625rem;
          top: 0.1875rem;
        }

        .bottom_border_r {
          width: 9.125rem;
          height: 1.75rem;
          border: 0.0625rem solid #f33d3d;
          font-size: 0.75rem;
          color: #f33d3d;
          position: relative;
          margin-top: 0.625rem;
          line-height: 1.75rem;

          span:nth-of-type(1) {
            width: 1.725rem;
          }

          span {
            display: inline-block;
            width: 7.4rem;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
          }
        }

        .bottom_border_r::before {
          width: 0.625rem;
          height: 0.625rem;
          content: url(../../../assets/redIcon.png);
          position: absolute;
          left: 0.625rem;
          top: 0.1875rem;
        }

        .bottom_border_y {
          width: 9.125rem;
          height: 1.75rem;
          border: 0.0625rem solid #dcb26e;
          font-size: 0.75rem;
          color: #dcb26e;
          position: relative;
          margin-top: 0.625rem;
          line-height: 1.75rem;

          span:nth-of-type(1) {
            width: 1.725rem;
          }

          span {
            display: inline-block;
            width: 7.4rem;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
          }
        }

        .bottom_border_y::before {
          width: 0.625rem;
          height: 0.625rem;
          content: url(../../../assets/yellowIcon.png);
          position: absolute;
          left: 0.625rem;
          top: 0.1875rem;
        }
      }
    }
  }

  .Site_Left_part2 {
    background: var(--cardbg-color);
    flex: 1;
    width: 100%;
    position: relative;
  }

  .Site_Left_part2::after {
    content: "";
    position: absolute;
    top: 0;
    right: 0;
    left: 0;
    border-top: 1px solid;
    border-image: linear-gradient(
        270deg,
        var(--borderImage),
        rgba(68, 215, 182, 1)
      )
      1 1;
    border-image-slice: 1;
  }
}

.Site_Right_Content {
  flex: 1;
  display: flex;
  flex-direction: column;
  margin-left: 1.25rem;

  .Site_Right_part1 {
    background: var(--cardbg-color);
    width: 100%;
    height: 60%;
    margin-bottom: 0.9375rem;
    display: flex;
    flex-direction: column;
    position: relative;

    .rightInfo_box {
      width: 11.125rem;
      height: 6.5625rem;
      border-radius: 0.125rem;
      border: 0.0625rem solid #ffffff38;
      display: flex;
      align-items: center;
      margin-left: 0.625rem;

      .box_item {
        display: flex;
        flex-direction: column;
        height: 2.5rem;
        justify-content: space-between;
      }

      img {
        height: 2.5rem;
        width: 2.5rem;
        padding: 0 1rem;
      }

      span:nth-of-type(1) {
        height: 1.125rem;
        font-size: 1.125rem;
        font-family: SourceHanSansCN-Regular, SourceHanSansCN;
        font-weight: 400;
        color: #44d7b6;
        line-height: 1.6875rem;
      }

      span:nth-of-type(2) {
        height: 0.875rem;
        font-size: 0.875rem;
        font-family: SourceHanSansCN-Regular, SourceHanSansCN;
        font-weight: 400;
        color: #6d7278;
        line-height: 1.3125rem;
      }
    }
  }

  .Site_Right_part1::after {
    content: "";
    position: absolute;
    top: 0;
    right: 0;
    left: 0;
    border-top: 1px solid;
    border-image: linear-gradient(
        270deg,
        var(--borderImage),
        rgba(68, 215, 182, 1)
      )
      1 1;
    border-image-slice: 1;
  }

  .Site_Right_part2 {
    background: var(--cardbg-color);
    width: 100%;
    flex: 1;
    display: flex;
    flex-direction: column;
    position: relative;

    .bottom-top {
      display: flex;
      align-items: center;
      margin: 0.5rem 0 0 0.75rem;
    }

    .bottom-t1 {
      font-size: 1rem;
      color: #44d7b6;
      font-weight: 400;
      margin-left: 0.5rem;
      margin-bottom: 0.125rem;
      cursor: pointer;
    }

    .bottom-t2 {
      font-size: 0.75rem;
      color: #6d7278;
      font-weight: 400;
      margin-left: 0.5rem;
      cursor: pointer;
    }

    .Table {
      max-height: 15.625rem;
      overflow: auto;
    }
  }

  .Site_Right_part2::after {
    content: "";
    position: absolute;
    top: 0;
    right: 0;
    left: 0;
    border-top: 1px solid;
    border-image: linear-gradient(
        270deg,
        var(--borderImage),
        rgba(68, 215, 182, 1)
      )
      1 1;
    border-image-slice: 1;
  }
}

.detailInfo {
  .firstSpan {
    padding-left: 0.875rem;
  }

  span:nth-of-type(1) {
    height: 0.875rem;
    font-size: 0.875rem;
    font-family: SourceHanSansCN-Regular, SourceHanSansCN;
    font-weight: 400;
    color: #5bb3bc;
    line-height: 1.3125rem;
    width: 12.5rem;
  }

  span:nth-of-type(2) {
    width: 0.5rem;
    height: 0.875rem;
    font-size: 0.875rem;
    font-family: SourceHanSansCN-Regular, SourceHanSansCN;
    font-weight: 400;
    line-height: 1.3125rem;
  }
}

.hover_con {
  position: fixed;
  width: 13.75rem;
  color: #5bb3bc;
  background: var(--hoverbg-color);
  box-shadow: 1rem 1.4375rem 0.375rem 0rem var(--hoversd-color);
  border: 0.0625rem solid var(--hoverbd-color);
  z-index: 10;

  .hover_top {
    display: flex;
    height: 2.375rem;
    border-bottom: 0.125rem solid #5bb3bc;
    padding: 0.3125rem;
    align-items: center;

    span {
      height: 1rem;
      line-height: 1rem;
      font-size: 1rem;
      font-family: SourceHanSansCN-Regular, SourceHanSansCN;
      font-weight: 400;
      color: var(--hoverTspan-color);
    }
  }

  .hover_bottom {
    display: flex;
    flex-direction: column;
    padding: 0.625rem;
    align-items: flex-start;
  }

  .hover_line {
    width: 0.3125rem;
    height: 1rem;
    background: #5bb3bc;
    border-radius: 0.0625rem;
    margin: 0 0.3125rem 0 0.625rem;
  }
}

@media screen and (max-width: 1440px) {
  .Site_main {
    width: 100%;
    height: 100%;
    font-size: 24px;
    z-index: 15;
    overflow: auto;
    box-sizing: border-box;
    display: flex;
  }

  .titleBox {
    display: flex;
    align-items: center;
    margin: 13px 0px 0px 24px;

    img {
      width: 16px;
      margin-right: 10px;
      height: 16px;
      background: rgba(68, 215, 202, 0.33);
      border: 1px solid #44d7b6;
    }

    span {
      width: 64px;
      height: 16px;
      font-size: 16px;
      font-family: SourceHanSansCN-Regular, SourceHanSansCN;
      font-weight: 400;
      color: #44d7b6;
      line-height: 18px;
      cursor: pointer;
    }
  }

  .Site_Left_Content {
    flex: 2.5;
    display: flex;
    flex-direction: column;

    .el-select {
      width: 215px !important;
      height: 40px !important;
      line-height: 40px !important;
    }

    .el-input__inner {
      width: 215px !important;
      height: 40px !important;
      line-height: 40px !important;
      font-size: 15px !important;
    }

    .el-input {
      width: 215px !important;
      height: 40px !important;
      line-height: 40px !important;
      font-size: 15px !important;
    }

    .Site_Left_part1 {
      background: url(../../../assets/siteBG.png) no-repeat;
      background-size: 100% 100%;
      height: 60%;
      width: 100%;
      margin-bottom: 15px;
      display: flex;
      flex-direction: column;

      .top {
        height: 10%;
        display: flex;
        align-items: center;
        justify-content: space-between;

        .top-select {
          margin-left: 20px;
        }

        .status-span {
          margin-right: 20px;
          font-size: 12px;
          color: #ffffff;
          line-height: 40px;
          width: 372px;
          height: 40px;

          display: flex;
          align-items: center;
          justify-content: space-around;
          box-shadow: 0 0 40px var(--statusbg-color) inset;

          img {
            width: 15px;
            height: 15px;
            padding: 0 5px;
          }

          .status-G-box {
            width: 47px;
            height: 27px;
            line-height: 27px;
            background: rgba(91, 179, 188, 0.3);
            border: 1px solid #5bb3bc;
            color: #5bb3bc;
            text-align: center;
          }

          .status-Y-box {
            width: 47px;
            height: 27px;
            line-height: 27px;
            background: rgba(220, 178, 110, 0.3);
            border: 1px solid #dcb26e;
            color: #dcb26e;
            text-align: center;
          }

          .status-O-box {
            width: 47px;
            height: 27px;
            line-height: 27px;
            background: rgba(255, 248, 237, 0);
            border: 1px solid #7f8488;
            color: #7f8488;
            text-align: center;
          }
          .status-R-box {
            width: 47px;
            height: 27px;
            line-height: 27px;
            background: rgba(243, 61, 61, 0.3);
            border: 1px solid #f33d3d;
            color: #f33d3d;
            text-align: center;
          }
        }

        .backgroundCorner {
          background: linear-gradient(to top, #4d97a0, #4d97a0) left top
              no-repeat,
            //上左
            linear-gradient(to right, #4d97a0, #4d97a0) left top no-repeat,
            //左上
            linear-gradient(to left, #4d97a0, #4d97a0) right top no-repeat,
            //上右
            linear-gradient(to bottom, #4d97a0, #4d97a0) right top no-repeat,
            //上右
            linear-gradient(to left, #4d97a0, #4d97a0) left bottom no-repeat,
            //下左
            linear-gradient(to bottom, #4d97a0, #4d97a0) left bottom no-repeat,
            //左下
            linear-gradient(to top, #4d97a0, #4d97a0) right bottom no-repeat,
            //下右
            linear-gradient(to left, #4d97a0, #4d97a0) right bottom no-repeat; //右下
          background-size: 1px 6px, 6px 1px, 1px 6px, 6px 1px;
        }
      }

      .bottom {
        flex: 1;
        display: flex;
        flex-wrap: wrap;
        overflow: auto;
        justify-content: flex-start;

        .bottom_Box {
          height: 145px;
          width: 166px;
          padding: 40px 40px 0px 40px;
          text-align: left;
          cursor: pointer;
          .bottom_BoxBg_o {
            width: 166px;
            height: 112px;
            text-align: center;
          }

          .bottom_BoxBg_o:hover {
            background: rgba(255, 248, 237, 0);
            width: 166px;
            height: 112px;
          }

          .bottom_BoxBg_y {
            width: 166px;
            height: 112px;
            text-align: center;
          }

          .bottom_BoxBg_y:hover {
            background: rgba(247, 181, 0, 0.2);
            width: 166px;
            height: 112px;
          }

          .bottom_BoxBg_r {
            width: 166px;
            height: 112px;
            text-align: center;
          }

          .bottom_BoxBg_r:hover {
            background: rgba(243, 61, 61, 0.5);
            width: 166px;
            height: 112px;
          }

          .bottom_BoxBg_g {
            width: 166px;
            height: 112px;
            text-align: center;
          }

          .bottom_BoxBg_g:hover {
            background: #15444681;
            width: 166px;
            height: 112px;
          }
          .bottom_border_o {
            width: 166px;
            height: 28px;
            border: 1px solid #7f8488;
            font-size: 12px;
            color: #7f8488;
            position: relative;
            margin-top: 10px;
            line-height: 28px;

            span:nth-of-type(1) {
              width: 30px;
            }

            span {
              display: inline-block;
              width: 128px;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
            }
          }

          .bottom_border_o::before {
            width: 10px;
            height: 10px;
            content: url(../../../assets/grayIcon.svg);
            position: absolute;
            left: 10px;
            top: 3px;
          }
          .bottom_border_g {
            width: 166px;
            height: 28px;

            .detailInfo {
              .firstSpan {
                padding-left: 14px;
              }

              span:nth-of-type(1) {
                height: 14px;
                font-size: 14px;
                font-family: SourceHanSansCN-Regular, SourceHanSansCN;
                font-weight: 400;
                color: #5bb3bc;
                line-height: 21px;
                width: 200px;
              }

              span:nth-of-type(2) {
                width: 8px;
                height: 14px;
                font-size: 14px;
                font-family: SourceHanSansCN-Regular, SourceHanSansCN;
                font-weight: 400;
                line-height: 21px;
              }
            }

            .hover_con {
              position: fixed;
              width: 220px;
              color: #5bb3bc;
              background: --hoverbg-color;
              box-shadow: 16px 23px 6px 0px rgba(0, 0, 0, 0.41);
              border: 1px solid #244447;

              .hover_top {
                display: flex;
                height: 38px;
                border-bottom: 2px solid #5bb3bc;
                padding: 5px;
                align-items: center;

                span {
                  height: 16px;
                  line-height: 16px;
                  font-size: 16px;
                  font-family: SourceHanSansCN-Regular, SourceHanSansCN;
                  font-weight: 400;
                  color: #deebff;
                }
              }

              .hover_bottom {
                display: flex;
                flex-direction: column;
                padding: 10px;
                align-items: flex-start;
              }

              .hover_line {
                width: 5px;
                height: 16px;
                background: #5bb3bc;
                border-radius: 1px;
                margin: 0 5px 0 10px;
              }
            }

            border: 1px solid #44d7b6;
            font-size: 12px;
            color: #44d7b6;
            position: relative;
            margin-top: 10px;
            line-height: 28px;

            span:nth-of-type(1) {
              width: 30px;
            }

            span {
              display: inline-block;
              width: 128px;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
            }
          }

          .bottom_border_g::before {
            width: 10px;
            height: 10px;
            content: url(../../../assets/greenIcon.png);
            position: absolute;
            left: 10px;
            top: 3px;
          }

          .bottom_border_r {
            width: 166px;
            height: 28px;
            border: 1px solid #f33d3d;
            font-size: 12px;
            color: #f33d3d;
            position: relative;
            margin-top: 10px;
            line-height: 28px;

            span:nth-of-type(1) {
              width: 30px;
            }

            span {
              display: inline-block;
              width: 128px;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
            }
          }

          .bottom_border_r::before {
            width: 10px;
            height: 10px;
            content: url(../../../assets/redIcon.png);
            position: absolute;
            left: 10px;
            top: 3px;
          }

          .bottom_border_y {
            width: 166px;
            height: 28px;
            border: 1px solid #dcb26e;
            font-size: 12px;
            color: #dcb26e;
            position: relative;
            margin-top: 10px;
            line-height: 28px;

            span:nth-of-type(1) {
              width: 30px;
            }

            span {
              display: inline-block;
              width: 128px;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
            }
          }

          .bottom_border_y::before {
            width: 10px;
            height: 10px;
            content: url(../../../assets/yellowIcon.png);
            position: absolute;
            left: 10px;
            top: 3px;
          }
        }
      }
    }

    .Site_Left_part2 {
      background: var(--cardbg-color);
      flex: 1;
      width: 100%;
    }
  }

  .Site_Right_Content {
    flex: 1;
    display: flex;
    flex-direction: column;
    margin-left: 20px;

    .Site_Right_part1 {
      display: flex;
      background: var(--cardbg-color);
      width: 100%;
      height: 60%;
      margin-bottom: 0.9375rem;
      flex-direction: column;
      position: relative;

      .rightInfo_box {
        width: 152px;
        height: 89px;
        border-radius: 2px;
        border: 1px solid #ffffff38;
        display: flex;
        align-items: center;
        margin-left: 10px;

        .box_item {
          display: flex;
          flex-direction: column;
          height: 40px;
          justify-content: space-between;
        }

        img {
          height: 40px;
          width: 40px;
          padding: 0 16px;
        }

        span:nth-of-type(1) {
          height: 18px;
          font-size: 18px;
          font-family: SourceHanSansCN-Regular, SourceHanSansCN;
          font-weight: 400;
          color: #44d7b6;
          line-height: 27px;
        }

        span:nth-of-type(2) {
          height: 14px;
          font-size: 14px;
          font-family: SourceHanSansCN-Regular, SourceHanSansCN;
          font-weight: 400;
          color: #6d7278;
          line-height: 21px;
        }
      }
    }

    .Site_Right_part2 {
      background: var(--cardbg-color);
      width: 100%;
      flex: 1;

      .bottom-top {
        display: flex;
        align-items: center;
        margin: 8px 0 0 12px;
      }

      .bottom-t1 {
        font-size: 16px;
        color: #44d7b6;
        font-weight: 400;
        margin-left: 8px;
        margin-bottom: 2px;
        cursor: pointer;
      }

      .bottom-t2 {
        font-size: 12px;
        color: #6d7278;
        font-weight: 400;
        margin-left: 8px;
        cursor: pointer;
      }

      .Table {
        max-height: 250px;
        overflow: auto;
      }
    }
  }

  .detailInfo {
    .firstSpan {
      padding-left: 14px;
    }

    span:nth-of-type(1) {
      height: 14px;
      font-size: 14px;
      font-family: SourceHanSansCN-Regular, SourceHanSansCN;
      font-weight: 400;
      color: #5bb3bc;
      line-height: 21px;
      width: 200px;
    }

    span:nth-of-type(2) {
      width: 8px;
      height: 14px;
      font-size: 14px;
      font-family: SourceHanSansCN-Regular, SourceHanSansCN;
      font-weight: 400;
      line-height: 21px;
    }
  }

  .hover_con {
    position: fixed;
    width: 220px;
    color: #5bb3bc;
    background: --hoverbg-color;
    box-shadow: 16px 23px 6px 0px rgba(0, 0, 0, 0.41);
    border: 1px solid #244447;

    .hover_top {
      display: flex;
      height: 38px;
      border-bottom: 2px solid #5bb3bc;
      padding: 5px;
      align-items: center;

      span {
        height: 16px;
        line-height: 16px;
        font-size: 16px;
        font-family: SourceHanSansCN-Regular, SourceHanSansCN;
        font-weight: 400;
        color: var(--hoverTspan-color);
      }
    }

    .hover_bottom {
      display: flex;
      flex-direction: column;
      padding: 10px;
      align-items: flex-start;
    }

    .hover_line {
      width: 5px;
      height: 16px;
      background: #5bb3bc;
      border-radius: 1px;
      margin: 0 5px 0 10px;
    }
  }
}
</style>
  
    


// WEBPACK FOOTER //
// src/pages/home/Site/index.vue